import React from 'react'
import { ActiveIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ActiveIcon'
import { Calendar2Icon } from '@frontend/pole-ui/lib/components/Icon/svg/Calendar2Icon'
import { TimerIcon } from '@frontend/pole-ui/lib/components/Icon/svg/TimerIcon'
import { WifiIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WifiIcon'
import { messages } from './messages'
import type { IFundingBannerInfoItem } from './types'

export const FUNDING_BANNER_INFO_ITEMS: IFundingBannerInfoItem[] = [
  {
    icon: <Calendar2Icon />,
    text: messages.infoItems.deadline,
  },
  {
    icon: <ActiveIcon />,
    text: messages.infoItems.approve,
  },
  {
    icon: <TimerIcon />,
    text: messages.infoItems.fiveDays,
  },
  {
    icon: <WifiIcon />,
    text: messages.infoItems.remotely,
  },
]
